import {
  APPOINTMENTS_ALL,
  APPOINTMENTS_ALL_SUCCESS,
  APPOINTMENTS_CREATE,
  APPOINTMENTS_CREATE_SUCCESS,
  APPOINTMENTS_DELETE,
  APPOINTMENTS_DELETE_SUCCESS,
  APPOINTMENTS_GET,
  APPOINTMENTS_GET_AGENDA,
  APPOINTMENTS_GET_AGENDA_FAILED,
  APPOINTMENTS_GET_AGENDA_SUCCESS,
  APPOINTMENTS_GET_BY_DATES,
  APPOINTMENTS_GET_BY_DATES_FAILED,
  APPOINTMENTS_GET_BY_DATES_SUCCESS,
  APPOINTMENTS_GET_SUCCESS,
  APPOINTMENTS_UPDATE,
  APPOINTMENTS_UPDATE_SUCCESS,
} from '../constants/Appointments';

export const getAllAppointments = (perPage, page) => ({
	type: APPOINTMENTS_ALL,
	perPage,
	page,
});

export const getAllAppointmentsSuccess = (appointments, from, to, total) => ({
	type: APPOINTMENTS_ALL_SUCCESS,
	appointments,
	from,
	to,
	total,
});

export const getAppointment = (id) => ({
	type: APPOINTMENTS_GET,
	id,
});

export const getAppointmentSuccess = (appointment) => ({
	type: APPOINTMENTS_GET_SUCCESS,
	appointment,
});

export const getAppointmentsByDate = (start, end) => ({
	type: APPOINTMENTS_GET_BY_DATES,
	start,
	end,
});

export const getAppointmentsByDateSuccess = (appointments) => ({
	type: APPOINTMENTS_GET_BY_DATES_SUCCESS,
	appointments,
});

export const getAppointmentsByDateFailed = () => ({
	type: APPOINTMENTS_GET_BY_DATES_FAILED,
});

export const updateAppointment = (id, data) => ({
  type: APPOINTMENTS_UPDATE,
  id,
  data
});

export const updateAppointmentSuccess = (appointment) => ({
  type: APPOINTMENTS_UPDATE_SUCCESS,
  appointment
});

export const createAppointment = (data) => ({
  type: APPOINTMENTS_CREATE,
  data
});

export const createAppointmentSuccess = (appointment) => ({
  type: APPOINTMENTS_CREATE_SUCCESS,
  appointment,
});

export const getAppointmentsAgenda = (date) => ({
  type: APPOINTMENTS_GET_AGENDA,
  date,
});

export const getAppointmentsAgendaSuccess = (agenda) => ({
  type: APPOINTMENTS_GET_AGENDA_SUCCESS,
  agenda,
});

export const getAppointmentsAgendaFailed = () => ({
	type: APPOINTMENTS_GET_AGENDA_FAILED,
});

export const deleteAppointment = (id) => ({
  type: APPOINTMENTS_DELETE,
  id
});

export const deleteAppointmentSuccess = (id) => ({
  type: APPOINTMENTS_DELETE_SUCCESS,
  id,
});